export const equipmentTypes = {
  cool_unit: {
    label: "Cool Unit",
    allowedSensors: ["temp"],
    stages: ["veg", "flower", "dry"],
    defaultSensor: "temp",
  },
  dehumidifier: {
    label: "Dehu",
    allowedSensors: ["amperage"],
    stages: ["veg", "flower", "dry"],
    defaultSensor: "humidity",
  },
  fogger: {
    label: "Fogger",
    allowedSensors: [],
    stages: ["veg", "flower", "dry"],
    defaultSensor: "humidity",
  },
};

export const sensorTypes = {
  temp: { label: "Temp Sensor" },
  amperage: { label: "Amperage Sensor" },
  humidity: { label: "Humidity Sensor" },
  co2: { label: "CO2 Sensor" },
};

export const stageColors = {
  veg: { bg: "#dcfce7", border: "#22c55e", text: "#166534" },
  flower: { bg: "#fef08a", border: "#eab308", text: "#713f12" },
  dry: { bg: "#fce7d7", border: "#fb923c", text: "#7c2d12" },
};

export const modeColors = {
  manual_on:  { bg: "#052e16", border: "#22c55e", text: "#4ade80", glow: "rgba(34,197,94,0.35)", label: "Manual On",  dot: "#22c55e" },
  manual_off: { bg: "#2a0a0a", border: "#ef4444", text: "#f87171", glow: "rgba(239,68,68,0.35)", label: "Manual Off", dot: "#ef4444" },
  auto:       { bg: "#0c1a2e", border: "#3b82f6", text: "#60a5fa", glow: "rgba(59,130,246,0.35)", label: "Automatic",  dot: "#3b82f6" },
};

export const modeList = ["manual_on", "manual_off", "auto"];

export const sensorSourceList = ["temp", "humidity", "co2"];
